/* Retired variant links are migration data on the product, never a price/SKU
 * index. The current native Shopify picker remains authoritative. */
(function () {
  'use strict';
  if (customElements.get('catalog-legacy-variant')) return;
  customElements.define('catalog-legacy-variant', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const url = new URL(location.href);
      const previous = url.searchParams.get('previous_variant');
      const oldId = previous || url.searchParams.get('variant');
      const route = JSON.parse(this.querySelector('[data-legacy-links]').textContent).routes?.[oldId];
      if (!route) return;
      const ru = this.dataset.locale === 'ru';
      const validPath = route.path && /^\/products\/[a-z0-9-]+$/.test(route.path);
      const targetVariant = /^\d+$/.test(route.variant || '') ? route.variant : null;
      const currentPath = url.pathname.replace(/^\/ru(?=\/products\/)/, '');
      // A retired size can belong to a different series even when there is no
      // exact replacement. Carry its notice there without selecting another SKU.
      if (validPath && (!previous || currentPath !== route.path)) {
        url.pathname = (ru ? '/ru' : '') + route.path;
        if (targetVariant) url.searchParams.set('variant', targetVariant);
        else url.searchParams.delete('variant');
        url.searchParams.set('previous_variant', oldId);
        location.replace(url.href);
        return;
      }
      this.querySelector('[data-legacy-notice]').textContent = route[ru ? 'ru' : 'uk'];
      this.hidden = false;
      this.style.display = 'block';
      // A discontinued material/diameter must not silently become the first
      // available SKU. Require a deliberate native option change before buying.
      if (!targetVariant) {
        const info = this.closest('[id^="ProductInfo-"]');
        const form = info?.querySelector('product-form');
        const picker = info?.querySelector('variant-selects, variant-radios');
        if (form && picker) {
          form.inert = true;
          form.style.opacity = '0.55';
          const addButton = form.querySelector('button[name="add"]');
          if (addButton) addButton.disabled = true;
          picker.addEventListener('change', () => {
            form.inert = false;
            form.style.opacity = '';
          }, { once: true });
        }
      }
    }
  });
})();
